import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

/**
 * VisitorLoginButton - Login/User button for visitor screens
 * Shows login icon when not authenticated
 * Shows user icon (navigates to member area) when authenticated
 */
const VisitorLoginButton = ({ className = '', variant = 'default' }) => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const { isDark } = useTheme();

  const handlePress = () => {
    if (isAuthenticated) {
      // Navigate to member home if authenticated
      navigate('/member/home');
    } else {
      // Navigate to login screen
      navigate('/login');
    }
  };

  // Style variants
  const getStyles = () => {
    switch (variant) {
      case 'header':
        // For colored headers (teal background)
        return 'bg-white/20 hover:bg-white/30 text-white';
      case 'dark-header':
        // For dark headers
        return 'bg-white/10 hover:bg-white/20 text-white';
      case 'transparent':
        // For transparent overlays (carousel)
        return 'bg-black/30 hover:bg-black/50 text-white backdrop-blur-sm';
      default:
        // For light backgrounds
        return isDark 
          ? 'bg-[#333333] hover:bg-[#3A3A3A] text-[#F2F1EB]'
          : 'bg-gray-100 hover:bg-gray-200 text-gray-700';
    }
  };

  // Authenticated users have Profil in the universal navbar — no need for this button
  if (isAuthenticated) {
    return null;
  }

  // Show login icon
  return (
    <button
      onClick={handlePress}
      className={`p-2.5 rounded-xl transition-all duration-200 ${getStyles()} ${className}`}
      data-testid="visitor-login-btn"
      aria-label="Se connecter"
    >
      <LogIn size={22} strokeWidth={2} />
    </button>
  );
};

export default VisitorLoginButton;
